import styled, { css } from "styled-components";
import { globalStyleMixins } from "../../globalStyleMixins";
import { responsiveArraySpreader } from "../../utils";

// Used to check if this Panel is descendant of a Panel:
var DescendantOfSelf = styled.div.withConfig({
  displayName: "Block__DescendantOfSelf",
  componentId: "sc-5tdpni-0"
})([""]);

export var Block = styled(DescendantOfSelf).withConfig({
  displayName: "Block",
  componentId: "sc-5tdpni-1"
})(["", " ", " ", " ", " ", "{padding-left:0rem;padding-right:0rem;}"], globalStyleMixins.background, globalStyleMixins.softRightCorner, globalStyleMixins.verticalSpace, function (props) {
  return responsiveArraySpreader(function (value) {
    return css(["padding-left:", "rem;padding-right:", "rem;"], value, value);
  }, props.theme.globalSitePadding);
}, DescendantOfSelf);